import { CdkDragDrop, DragDropModule } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@next/core-lib/i18n';
import {
  ECOSYSTEM_PRIORITIES,
  ECOSYSTEM_PRIORITY_LIMIT,
  EcosystemPriority,
  PRIORITY_LABEL_KEYS,
} from '../green-manure.model';

@Component({
  selector: 'app-priority-ranking',
  imports: [DragDropModule, MatIconButton, MatIcon, TranslatePipe],
  templateUrl: './priority-ranking.component.html',
  styleUrl: './priority-ranking.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriorityRankingComponent {
  readonly selection = model.required<EcosystemPriority[]>();
  readonly limit = ECOSYSTEM_PRIORITY_LIMIT;
  readonly weightKeys = ['highestWeight', 'middleWeight', 'lowestWeight'] as const;
  readonly priorityLabelKeys = PRIORITY_LABEL_KEYS;
  readonly priorityIcons: Record<EcosystemPriority, string> = {
    OrganicMatter: 'eco',
    PestControl: 'bug_report',
    WeedSuppression: 'grass',
    NutrientLeaching: 'opacity',
    Biodiversity: 'emoji_nature',
    NitrogenFixation: 'science',
  };
  readonly available = computed(() => ECOSYSTEM_PRIORITIES.filter((priority) => !this.selection().includes(priority)));
  readonly full = computed(() => this.selection().length >= this.limit);

  place(priority: EcosystemPriority, index: number | null): void {
    this.selection.update((current) => {
      if (index !== null && !current.includes(priority) && current.length >= this.limit) return current;
      const next = current.filter((entry) => entry !== priority);
      if (index !== null) next.splice(index, 0, priority);
      return next;
    });
  }

  drop(event: CdkDragDrop<EcosystemPriority[], EcosystemPriority[], EcosystemPriority>): void {
    this.place(event.item.data, event.currentIndex);
  }
}
